const formatterValue = new Intl.NumberFormat(
    'pt-BR',{
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2
});

module.exports = {
    formatterValue
}